// extracted by mini-css-extract-plugin
export var deleteIcon = "_qq-5";
export var deleteOption = "_qq-3";
export var divider = "_qq-2";
export var downloadIcon = "_qq-4";
export var drawer = "_qq-0";
export var drawerFooter = "_qq-6";
export var drawerOpen = "_qq-1";
export var highlighted = "_qq-7";
export var lighterHighlight = "_qq-8";